import type { ObjectSchema } from "yup";
import { object, string } from "yup";

import type { RestoreCredential } from "~/shared/utils/auth-poker-sdk/auth-poker-sdk";

export const createRestoreValidationSchema = (t: {
  validation_required: string;
  validation_invalid: string;
}): ObjectSchema<RestoreCredential> => {
  return object({
    email: string().required(t.validation_required).email(t.validation_invalid),
  });
};
